module.exports = __webpack_public_path__ + "static/857552158.f0610789.jpg";